import { render } from "./DocRequestModal.vue?vue&type=template&id=264d5809"
import script from "./DocRequestModal.vue?vue&type=script&lang=js"
export * from "./DocRequestModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__